import mergeWith from 'lodash/mergeWith'
import { DeepPartial } from 'utility-types'

import { AiAutomationConfig, KnowledgeEntry } from 'shared/api/requests/aiAutomation/schemas'

const applyChangesToConfig = (
  config: AiAutomationConfig,
  changes: DeepPartial<AiAutomationConfig>,
  isNewKnowledgeEnabled: boolean,
) => {
  const newConfig: AiAutomationConfig = mergeWith(
    {},
    config,
    changes,
    (targetValue, sourceValue) => {
      if (Array.isArray(targetValue)) {
        return sourceValue
      }
    },
  )

  if (newConfig.business_context && newConfig.business_context.length === 0) {
    newConfig.scenarios.faq.published = false
  }

  if (isNewKnowledgeEnabled) {
    delete newConfig.business_context
  }

  return newConfig
}

const removeKnowledgeEntry = (knowledge: KnowledgeEntry[], indexToRemove: number) => {
  return knowledge.filter((_, index) => index !== indexToRemove)
}

const updateKnowledgeEntry = (
  knowledge: KnowledgeEntry[],
  indexToUpdate: number,
  newEntryValue: KnowledgeEntry,
) => {
  return knowledge.map((entry, index) => {
    if (index !== indexToUpdate) {
      return entry
    }

    return newEntryValue
  })
}

export const AiAutomationModel = {
  applyChangesToConfig,
  removeKnowledgeEntry,
  updateKnowledgeEntry,
}
